/** ECharts 配色与通用 grid，与 DashboardView 保持一致。 */
export const ENGAGEMENT_CHART_COLORS = ['#2f6af6', '#22c3ee', '#8b5cf6', '#12b76a', '#f79009']

export function engagementGrid() {
  return { left: 36, right: 16, top: 36, bottom: 28 }
}

export function formatRangeParams(preset, customStart, customEnd) {
  const now = new Date()
  const end = customEnd ? new Date(customEnd) : now
  let start
  if (preset === '30') {
    start = new Date(end)
    start.setDate(start.getDate() - 29)
  } else if (preset === '365') {
    start = new Date(end)
    start.setDate(start.getDate() - 364)
  } else if (customStart) {
    start = new Date(customStart)
  } else {
    start = new Date(end)
    start.setDate(start.getDate() - 89)
  }
  start.setHours(0, 0, 0, 0)
  // 结束日期含当天全天（避免晚间签到/报名被截掉）
  end.setHours(23, 59, 59, 999)
  return {
    start: toApiDateTime(start),
    end: toApiDateTime(end),
  }
}

function pad2(n) {
  return String(n).padStart(2, '0')
}

export function toApiDateTime(d) {
  if (!d || Number.isNaN(d.getTime())) return ''
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`
}

export function toDateInputValue(d) {
  if (!d || Number.isNaN(d.getTime())) return ''
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

/** 活跃度列表「身份」列中文展示（正式会员单独标识，其余注册账号均为已注册） */
const MEMBER_STATUS_LABELS = {
  ACTIVE: '正式会员',
}

export function engagementIdentityLabel(row) {
  if (row?.registered === false) return '未注册'
  const code = String(row?.statusCode || '').trim().toUpperCase()
  if (MEMBER_STATUS_LABELS[code]) return MEMBER_STATUS_LABELS[code]
  // 后端已返回中文
  if (/[\u4e00-\u9fff]/.test(String(row?.statusCode || ''))) return String(row.statusCode).trim()
  if (code) return '已注册'
  return '—'
}

export function engagementViewBreakdownLines(row) {
  const article = Number(row?.articleViewCount ?? 0)
  const album = Number(row?.albumViewCount ?? 0)
  const activity = Number(row?.activityViewCount ?? 0)
  const supply = Number(row?.supplyViewCount ?? 0)
  return [
    `资讯：${article}`,
    `相册：${album}`,
    `活动：${activity}`,
    `供需：${supply}`,
  ]
}

export function engagementViewTotal(row) {
  return engagementViewBreakdownLines(row)
    .map((line) => Number(String(line).split('：')[1] || 0))
    .reduce((sum, n) => sum + n, 0)
}

export function exportEngagementCsv(rows) {
  const header = ['姓名', '手机', '单位', '身份', '报名', '签到', '资讯浏览', '相册浏览', '活动浏览', '供需浏览', '问卷', '行为合计', '最近活跃']
  const lines = [header.join(',')]
  for (const r of rows || []) {
    lines.push([
      csvCell(r.registerName),
      csvCell(r.registerMobile),
      csvCell(r.registerCompanyName),
      csvCell(engagementIdentityLabel(r)),
      r.signupCount ?? 0,
      r.checkinCount ?? 0,
      r.articleViewCount ?? 0,
      r.albumViewCount ?? 0,
      r.activityViewCount ?? 0,
      r.supplyViewCount ?? 0,
      r.surveyCount ?? 0,
      r.totalBehaviorCount ?? 0,
      csvCell(r.lastActiveAt),
    ].join(','))
  }
  const blob = new Blob(['\ufeff' + lines.join('\n')], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `会员活跃度_${Date.now()}.csv`
  a.click()
  URL.revokeObjectURL(url)
}

function csvCell(v) {
  const s = String(v ?? '').replace(/"/g, '""')
  return `"${s}"`
}
